import { useEffect } from 'react'
import MuiBox from '@mui/material/Box'
import { useFormik, Form, FormikProvider } from 'formik'
import * as Yup from 'yup'
import FormikControl from '../../../components/formik-control'
import { usePostUserMutation } from '../slice'

const AddUserForm = ({ onSubmitEvent, setSubmitEvent, setShowDrawer }) => {
  const [postUser] = usePostUserMutation()
  const initialValues = {
    password: '',
    givenName: '',
    familyName: '',
    email: '',
    phoneNumber: '',
  }

  const validationSchema = Yup.object({
    givenName: Yup.string().required('Required'),
    familyName: Yup.string().required('Required'),
    email: Yup.string().email('Invalid email format').required('Required'),
    phoneNumber: Yup.string().required('Required'),
    password: Yup.string().min(8).required('Required'),
  })

  const onSubmit = async (values) => {
    await postUser(values)
    setSubmitEvent()
    setShowDrawer(false)
  }

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit,
  })

  useEffect(() => {
    if (onSubmitEvent) {
      formik.handleSubmit()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onSubmitEvent])

  return (
    <FormikProvider value={formik}>
      <Form>
        <MuiBox>
          <FormikControl control="input" label="Email" name="email" fullWidth margin="normal" />
        </MuiBox>
        <MuiBox>
          <FormikControl control="input" label="Password" name="password" fullWidth margin="normal" type="password" />
        </MuiBox>
        <MuiBox>
          <FormikControl control="input" label="First Name" name="givenName" fullWidth margin="normal" />
        </MuiBox>
        <MuiBox>
          <FormikControl control="input" label="Last Name" name="familyName" fullWidth margin="normal" />
        </MuiBox>
        <MuiBox>
          <FormikControl control="input" label="Phone" name="phoneNumber" fullWidth margin="normal" />
        </MuiBox>
      </Form>
    </FormikProvider>
  )
}

export default AddUserForm
